module.exports = __webpack_public_path__ + "static/me_hobby-9759a521732f2577e597d8d38a0049de.jpg";